import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";

// Inner-page hero with breadcrumb + eyebrow, optional image backdrop.
export default function PageHero({ eyebrow, title, description, breadcrumb = [], image }) {
  return (
    <section className="relative overflow-hidden bg-navy-deep pt-[84px] lg:pt-[104px]">
      {image && (
        <>
          <img src={image} alt="" aria-hidden className="absolute inset-0 h-full w-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-r from-navy-deep via-navy-deep/90 to-navy/60" />
        </>
      )}
      {!image && <div className="absolute inset-0 bg-blueprint-dark opacity-40" />}
      <div className="pointer-events-none absolute -left-20 top-10 h-72 w-72 rounded-full bg-brand/20 blur-[120px]" />

      <div className="container-sky relative py-16 sm:py-20 lg:py-28">
        {breadcrumb.length > 0 && (
          <nav className="mb-6 flex flex-wrap items-center gap-1.5 text-xs text-slate-300" aria-label="Breadcrumb">
            {breadcrumb.map((b, i) => (
              <span key={b.path} className="flex items-center gap-1.5">
                {i > 0 && <ChevronRight className="h-3.5 w-3.5 text-slate-500" />}
                {i === breadcrumb.length - 1 ? (
                  <span className="text-brand-light">{b.name}</span>
                ) : (
                  <Link to={b.path} className="transition-colors hover:text-white">{b.name}</Link>
                )}
              </span>
            ))}
          </nav>
        )}
        {eyebrow && (
          <motion.span
            initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
            className="tech-tag text-brand-light"
          >
            {eyebrow}
          </motion.span>
        )}
        <motion.h1
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.05 }}
          className="mt-4 max-w-4xl font-heading text-4xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl"
        >
          {title}
        </motion.h1>
        {description && (
          <motion.p
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.15 }}
            className="mt-6 max-w-2xl text-lg leading-relaxed text-slate-300"
          >
            {description}
          </motion.p>
        )}
      </div>
    </section>
  );
}
